import axios from "axios";
import AuthService from "./auth.services";

const API_URL = "/api/v1/account/";

const authHeaders = () => ({
  headers: {
    Authorization: `Bearer ${AuthService.getCurrentUser()?.accessToken || ""}`,
  },
});

const getMyProfile = () => {
  return axios.get(`${API_URL}profile`, authHeaders());
};

const updateMyProfile = (payload) => {
  return axios.put(`${API_URL}profile`, payload, authHeaders());
};

const changeMyPassword = (payload) => {
  return axios.put(`${API_URL}password`, payload, authHeaders());
};

const ProfileServices = {
  getMyProfile,
  updateMyProfile,
  changeMyPassword,
};

export default ProfileServices;
